import { captureMessage } from '@sentry/react';
import type { IUnitValuesMap } from 'utils/constants';
import { isRunningTest } from 'utils/platform';

import { translateString } from './translateString';

export enum UnitEnumHardCoded {
  CM = 'cm',
  IN = 'in',
  IN_SYMBOL = '"',
  INCHES = 'inches'
}

export enum UnitEnumTranslationKeys {
  CM = 'measureValueCm'
}

export interface IUnitValues {
  metric: string;
  imperial: string;
}

export const getValueWithUnit = (value: IUnitValues, useMetric?: boolean) => {
  const localizedValue = useMetric ? value.metric : value.imperial;

  // If last character is a number we add the default unit ( cm or in )
  const showUnit = useMetric !== null && !Number.isNaN(Number(localizedValue.slice(-1)));
  const cm = isRunningTest ? UnitEnumHardCoded.CM : translateString(UnitEnumTranslationKeys.CM);
  const unitExtension = useMetric ? ` ${cm}` : UnitEnumHardCoded.IN_SYMBOL;

  return showUnit ? localizedValue + unitExtension : localizedValue;
};

export const replaceValuesInString = (translatedText: string, placeholderValues: IUnitValuesMap, useMetric?: boolean) => {
  return Object.entries(placeholderValues).reduce((originalString, [placeholderKey, value]) => {
    // Use regex to allow for multiple replacement of same key
    const regex = new RegExp(`\\{\\{${placeholderKey}}}`, 'g');

    // Use original value or convert it to include unit extension if it is of type IUnitValues
    const formattedValue = typeof value !== 'object' ? value : getValueWithUnit(value, useMetric);

    // Check whether the returned value is the same as the original string to determine if there were no matches found.
    const newString = originalString.replace(regex, formattedValue);

    // Return originalString if no match was found
    if (newString === originalString) {
      captureMessage('No placeholder key for translation found.', (scope) => {
        scope.setExtra('key', placeholderKey);
        return scope;
      });
      return originalString;
    }

    return newString;
  }, translatedText);
};
